import React from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";

const PaymentInfo = ({ data, updateData, onSubmitStep, onBackStep }) => {
	const validationSchema = Yup.object().shape({
		banco: Yup.string().required("Nome do banco é obrigatório"),
		agencia: Yup.number().required("Número da agência é obrigatório"),
		contaCorrente: Yup.number().required("Número da conta é obrigatório"),
	});

	let submitTimeout;

	return (
		<div>
			<h4>Dados Bancários</h4>
			<Formik
				initialValues={{
					banco: data.banco || "",
					agencia: data.agencia || "",
					contaCorrente: data.contaCorrente || "",
				}}
				validationSchema={validationSchema}
				onSubmit={(values, actions) => {
					actions.setSubmitting(true);
				
					clearTimeout(submitTimeout);
				
					submitTimeout = setTimeout(async () => {
						try {
							await updateData(values);
							onSubmitStep();
						} catch (error) {
							console.error("Error during submission:", error);
							actions.setStatus("Erro ao enviar o formulário");
						} finally {
							setTimeout(() => actions.setSubmitting(false), 1000);
						}
					}, 1000);
				}}
			>
				{({ errors, isSubmitting, submitCount, touched }) => (
					<Form>
						{submitCount > 0 && Object.keys(errors).length > 0 && (
							<div className="alert alert-danger mb-3">
								<span className="text-4">
									Verifique os campos abaixo para continuar:
								</span>
								<ul className="mb-0">
									{Object.entries(errors).map(
										([field, error]) => (
											<li key={field}>{error}</li>
										)
									)}
								</ul>
							</div>
						)}

						<div className="row">
							<div className="form-group required d-flex flex-column col-md-4 col-12">
								<label htmlFor="banco" className="form-label">
									Banco
								</label>
								<Field
									name="banco"
									type="text"
									className="form-control form-field"
								/>
								{errors.banco && touched.banco ? (
									<div className="invalid-feedback d-block">
										{errors.banco}
									</div>
								) : null}
							</div>
							<div className="form-group required d-flex flex-column col-md-4 col-12">
								<label htmlFor="agencia" className="form-label">
									Agência
								</label>
								<Field
									name="agencia"
									type="text"
									className="form-control form-field"
								/>
								{errors.agencia && touched.agencia ? (
									<div className="invalid-feedback d-block">
										{errors.agencia}
									</div>
								) : null}
							</div>
							<div className="form-group required d-flex flex-column col-md-4 col-12">
								<label
									htmlFor="contaCorrente"
									className="form-label"
								>
									Conta corrente
								</label>
								<Field
									name="contaCorrente"
									type="text"
									className="form-control form-field"
								/>
								{errors.contaCorrente &&
								touched.contaCorrente ? (
									<div className="invalid-feedback d-block">
										{errors.contaCorrente}
									</div>
								) : null}
							</div>
						</div>

						<div className="d-flex justify-content-between">
							<button
								type="button"
								className="btn btn-secondary"
								onClick={onBackStep}
							>
								Anterior
							</button>
							<button
								type="submit"
								className={`btn btn-primary ${
									isSubmitting ? "disabled" : ""
								}`}
								disabled={isSubmitting}
							>
								{isSubmitting ? "Enviando..." : "Concluir"}
							</button>
						</div>
					</Form>
				)}
			</Formik>
		</div>
	);
};

export default PaymentInfo;
